import withPersistedColumns from './hoc/withPersistedColumns';
import withPersistedParameters from './hoc/withPersistedParameters';
import { default as _ListPage } from './ListPage';
import { default as _StaticListPage } from './StaticListPage';
import { withReduxConnector } from './hoc/withReduxConnector';

export const ListPageWithPersisted = withReduxConnector(withPersistedColumns(withPersistedParameters(_ListPage)));
export const ListPage = _ListPage;
export * from './helper';

export const StaticListPageWithPersisted = withReduxConnector(withPersistedColumns(withPersistedParameters(_StaticListPage)));
export const StaticListPage = _StaticListPage;
